module.exports = __webpack_public_path__ + "media/images/sp/specials/common/clean_ribbon_gold-eae19a4ce3c6ee93d129e1178c42b6c0.svg";